import React, { useContext, useMemo } from "react";
import ConfigContext from "../context/ConfigContext";
import { Table } from "./Table";
import "./Table.css";

export const LoansAndNotes = ({ loans }) => {
	const configData = useContext(ConfigContext);

	const getReportLink = (fileName) => {
		const link = document.createElement("a");
		link.href = `${configData.REACT_APP_LOANS_AND_NOTES_URL}/pdf/${fileName}`;
		document.body.appendChild(link);
		return link;
	};

	function viewReport(fileName) {
		const link = getReportLink(fileName);
		link.setAttribute("target", "_blank");
		link.click();
	};

	const data = useMemo(() => loans, [loans]);
	const columns = useMemo(() => [
		{
			Header: "Type",
			id: 1,
			accessor: "type"
		},
		{
			Header: "File Name",
			id: 2,
			accessor: "fileName"
		},
		{
			Header: "View",
			id: 3,
			accessor: "fileName",
			Cell: e => <button className="btnPdf" onClick={() => viewReport(e.value)} data-testid={e.value}></button>
		}
	], []);

	return (
		<div>
			{data && <Table columns={columns} data={data} />}
		</div>
	);
};